import dayjs from "dayjs"

export const formatter = {
  currency: (data:any, type:any) => {
    if( !data ) return ""
    let currencySymbol = (type === "USD") ? "$" : (type === "EUR") ? "€" : ""
    // return `${currencySymbol}${parseFloat(data).toFixed(2)}`
    return formatter.matchApiFormat(data, `currency:${type.toLowerCase()}`) // Use the matchApiFormat function to handle different currency formats
  },

  date: (data:any, configStr:any) => {
    if( !data ) return ""
    let format = configStr || "MM/DD/YYYY"
    // return dayjs(data).format(format) 
    return formatter.matchApiFormat(data, `date:${format}`) // Use the matchApiFormat function to handle different date formats
  },

  matchApiFormat: (clientData:any, format:string) => {
    let formatType
    let formatConfig 

    if( format.includes(":") ){
      formatType = format?.split(":")[0]
      formatConfig = format?.split(":")[1] || ""
    } else if( format.includes("|") ){
      formatType = format?.split("|")[0]  
      formatConfig = format?.split("|")[1] || ""
    } else {
      return clientData // If no specific format, return as is
    }

    switch(formatType) {
      case "currency":
        switch(formatConfig) {
          case "match":
            return clientData; // No change, match the API data format
          case "usd":
            return `$${clientData}`
          case "euro":
            return `€${clientData}`
          default:
            return clientData; // Default case, return as is
        }
      case "date":
        console.log("formatConfig", formatConfig)
        switch(formatConfig) {
          case "dddd, MMM DD, YYYY":
            return dayjs(clientData).format("ddd, MMM DD, YYYY");
          case "MM/DD/YYYY":
            return dayjs(clientData).format("MM/DD/YYYY");
          case "MMM DD, YYYY":
            return dayjs(clientData).format("MMM DD, YYYY");
          case "MMMM D, YYYY":
            return dayjs(clientData).format("MMMM D, YYYY");
          case "MMMM D, YYYY h:mm A":
            return dayjs(clientData).format("MMMM D, YYYY h:mm A");
          default:
            return dayjs(clientData).format(formatConfig); // Default case, return as is
        }
      default:
        return clientData; // If no specific format, return as is

    }

  }
}
